module.exports = __webpack_public_path__ + "static/media/rustLogo.5067a671.png";